import { observer } from "mobx-react"

const About = observer(() => {
    return (<>
        <section className="about-section position-relative py-5" id="about">
            <div className="container text-center">
                <h2 className="weird-subtitle">About SnowballBoss</h2>
                <p className="mt-4 text-center">
                SnowballBoss is a next-generation memecoin built on the Binance Smart Chain (BSC), aiming to combine entertainment, finance, and community in an innovative and engaging way. Inspired by the mischievous Snowball from The <em> Secret Life of Pets </em>, SnowballBoss brings a playful spirit to the crypto space while offering unique features designed for both fun and functionality. With a focus on robust tokenomics, enhanced security measures, and a community-driven governance model, SnowballBoss is more than just a memecoin—it’s a platform for innovation and connection. Whether you're a seasoned investor or new to crypto, SnowballBoss promises an exciting journey, blending the thrill of finance with the joy of community.
                </p>
            </div>
        </section>
    </>)
});

export default About;